<template>
  <footer class="footer has-text-black-ter" :style="{ backgroundColor: config.footer_bgcolor}">
    <div class="container">
      <div class="columns">
        <div class="column">
          <div class="columns">
            <div class="column">
              <img
                ngsrc="assets/logos/logo-smile.svg"
                alt="KidsTopia"
                width="200"
                height="170"
                class="mb-2"
                loading="lazy"
                fetchpriority="auto"
                ng-img="true"
                src="@/assets/img/logo-smile.svg"
              />
            </div>
          </div>
          <span>© 2020 - 2025 </span>
        </div>
        <div class="column">
          <div>
            <strong class="is-uppercase">LOCATIONS</strong>
            <ul class="mt-2">
              <li v-for="(item, index) in shopList" :key="index">
                <div class="media">
                  <div
                    class="media-left"
                    
                  >
                    <img
                      class="fas fa-map-marker-alt has-text-primary footer-img"
                      src="../../assets/img/local_footer.png"
                    />
                  </div>
                  <div class="media-content">
                    <a
                      :href="`https://${item.domain}`"
                      class="has-text-primary has-text-weight-semibold title is-6"
                      >{{ item.name }}</a
                    >
                    <p v-html="item.address"></p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="mt-4" v-if="config.email">
            <strong class="is-uppercase">CONTACT</strong>
            <ul class="mt-2">
              <li>
                <a
                  :href="`mailto:${config.email}`"
                  class="has-text-black-ter link email-wrap"
                >
                  <img
                      class="far fa-envelope has-text-primary mr-2 email-log"
                      src="../../assets/img/email.png"
                    />
                  {{ config.email }}
                </a>
              </li>
            </ul>
          </div>
          <div class="mt-4">
            <strong class="is-uppercase">CONNECT WITH US</strong>
            <ul class="mt-2">
              <li>
                <a
                  v-if="config.fb_account"
                  @click="openOther(config.fb_account)"
                  target="_blank"
                  class="mr-4"
                  style="cursor: pointer"
                  ><img
                    height="25"
                    width="25"
                    alt="KidsTopia Facebook"
                    loading="lazy"
                    fetchpriority="auto"
                    src="@/assets/img/logo-FB.png" /></a
                ><a
                  v-if="config.instagram_account"
                  @click="openOther(config.instagram_account)"
                  target="_blank"
                  style="cursor: pointer"
                  ><img
                    ngsrc="assets/logos/logo-INS.png"
                    height="25"
                    width="25"
                    alt="KidsTopia Instagram"
                    loading="lazy"
                    fetchpriority="auto"
                    ng-img="true"
                    src="@/assets/img/logo-INS.png"
                /></a>
              </li>
            </ul>
          </div>
          <div class="mt-4 is-hidden-tablet">
            <hr />
            <strong class="is-uppercase">EXPLORE</strong>
            <ul class="mt-2">
              <li v-for="(item, index) in footerTabList" :key="index">
                <a class="has-text-black-ter link" @click="openLink(item.path)">
                  {{ item.title }}
                  <span
                    v-if="item.show_hot == 1"
                    class="tag has-text-weight-semibold is-danger ml-2"
                    >HOT</span
                  >
                </a>
              </li>
            </ul>
            <hr />
            <ul>
              <li>
                <a class="has-text-black-ter link" href="/policy/privacy"
                  >Privacy Policy</a
                >
              </li>
              <li>
                <a class="has-text-black-ter link" href="/policy/terms"
                  >Terms and Conditions</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="column is-hidden-mobile">
          <strong class="is-uppercase">EXPLORE</strong>
          <ul class="mt-2">
            <li v-for="(item, index) in footerTabList" :key="index">
              <a class="has-text-black-ter link" :href="item.path">
                {{ item.title }}
                <span
                  v-if="item.show_hot == 1"
                  class="tag has-text-weight-semibold is-danger ml-2"
                  >HOT</span
                >
              </a>
            </li>
          </ul>
          <hr />
          <ul>
            <li>
              <a
                class="has-text-black-ter link"
                @click="openLink('/policy/privacy')"
                >Privacy Policy</a
              >
            </li>
            <li>
              <a
                class="has-text-black-ter link"
                @click="openLink('/policy/terms')"
                >Terms and Conditions</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import appData from "@/utils/app_data";
import store from "@/store";
export default {
  props: {
    config: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      appData: appData,
    };
  },
  computed: {
    shopList() {
      return store.state.global.shopLists || [];
    },
    footerTabList() {
      return store.state.global.footerTabs || [];
    },
  },
  created() {},
  methods: {
    openOther(url) {
      window.open(`${url}/?from=web-footer`);
    },
    openLink(path) {
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>
<style scoped>
.footer {
  background-color: #fafafa;
  padding: 3rem 1.5rem 6rem;
}
.has-text-black-ter {
  color: #242424 !important;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.link {
  cursor: pointer;
}
.link:hover {
  font-weight: 600;
}
a.has-text-primary:hover,
a.has-text-primary:focus {
  color: #d1262b !important;
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}

.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
.columns:not(:last-child) {
  margin-bottom: 0rem;
}
@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}
@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}
img {
  height: auto;
  max-width: 100%;
}
.mb-2 {
  margin-bottom: 0.5rem !important;
}
span {
  font-style: inherit;
  font-weight: inherit;
}
strong {
  color: #363636;
  font-weight: 700;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
ul {
  list-style: none;
}
.media {
  align-items: flex-start;
  display: flex;
  text-align: inherit;
}
.media-left,
.media-right {
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
}
.media-left {
  margin-right: 1rem;
}
.fas,
.fa-classic,
.fa-solid,
.far,
.fa-regular {
  font-family: "Font Awesome 6 Free";
}
.fas,
.fa-solid {
  font-weight: 900;
}
.has-text-primary {
  color: #de4c50 !important;
}
.fa-map-marker-alt:before {
  content: "\f3c5";
}
.media-content {
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  text-align: inherit;
}
.tabs:not(:last-child),
.pagination:not(:last-child),
.message:not(:last-child),
.level:not(:last-child),
.breadcrumb:not(:last-child),
.block:not(:last-child),
.title:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.progress:not(:last-child),
.notification:not(:last-child),
.content:not(:last-child),
.box:not(:last-child) {
  margin-bottom: 1.5rem;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.title.is-6 {
  font-size: 1rem;
}
.mt-4 {
  margin-top: 1rem !important;
}
@media screen and (min-width: 769px) {
  .is-hidden-tablet {
    display: none !important;
  }
}
hr {
  background-color: #f5f5f5;
  border: none;
  display: block;
  height: 2px;
  margin: 1.5rem 0;
}
.mr-4 {
  margin-right: 1rem !important;
}

.tag:not(body).is-danger {
  background-color: #de4c50;
  color: #fff;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.link {
  cursor: pointer;
}
.footer-img {
  max-width: 18px;
  height: 22px;
}
.email-log {
  max-width: 20px;
}
.email-wrap {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/layout/components/ParentFooter.vue